import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsService } from './settings.service';
import { applyCspNonce } from '../../utils/csp-nonce.util';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SettingsService
  ]
})
export class SettingsModule {
  constructor() {
    // Dynamically load JSON Editor if not already loaded
    this.loadJSONEditor();
  }

  private loadJSONEditor() {
    if (typeof window !== 'undefined' && !document.getElementById('json-editor-script')) {
      const script = document.createElement('script');
      script.id = 'json-editor-script';
      applyCspNonce(script);
      script.src = 'https://cdn.jsdelivr.net/npm/@json-editor/json-editor@latest/dist/jsoneditor.min.js';
      script.async = true;
      document.body.appendChild(script);
      
      // Load FontAwesome if needed (for icons)
      if (!document.querySelector('link[href*="font-awesome"]')) {
        const fontAwesome = document.createElement('link');
        fontAwesome.rel = 'stylesheet';
        fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
        document.head.appendChild(fontAwesome);
      }
    }
  }
} 